import { css } from '@emotion/react'
import { Link } from 'gatsby'
import { twitterUrl } from '../socialLinks'

const footerCss = {
  self: css({
    borderTop: '1px solid var(--light-midnight)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
  ul: css({
    display: 'flex',
    listStyle: 'none',
    padding: '8px 16px',
    margin: '0 auto',
    maxWidth: 768,
    li: {
      padding: '0 8px',
      ':not(:last-child)': {
        borderRight: '1px solid var(--light-midnight)',
      },
    },
  }),
  small: css({ padding: 8 }),
}

export default function Footer() {
  return (
    <footer css={footerCss.self}>
      <ul css={footerCss.ul}>
        <li>
          <Link to={twitterUrl.href} target="_blank">
            Твіттер
          </Link>
        </li>
        <li>
          <Link to="mailto:minmaxfm@fastmail.to">Пошта</Link>
        </li>
      </ul>
      <small css={footerCss.small}>&copy;{new Date().getFullYear()}</small>
    </footer>
  )
}
